import React from 'react'
import classes from 'classnames'

export default ({ Left, Right, Exit, className }) => {
  const sidebarFooterClasses = classes('Text', 'Sidebar__footer', className)
  // 'Sidebar__footer_person': isPerson

  return (
    <div className={sidebarFooterClasses}>
      {Left && Left}
      {Right && Right}
      {Exit && Exit}
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/Sidebar/Footer.jsx